import type { FluidPlugin } from './plugin/FluidPlugin';
import { preloadFluid, preloadFluidScripts } from 'owa-fluid-tenantconfig';
import createLazyPlugin, { LazyPlugin } from 'owa-editor-lazy-plugin/lib/utils/createLazyPlugin';
import {
    createLazyComponent,
    LazyModule,
    LazyImport,
    LazyAction,
    registerLazyOrchestrator,
} from 'owa-bundling';
import { PluginEventType } from 'roosterjs-editor-types';
import PluginNames from 'owa-editor-lazy-plugin/lib/utils/PluginNames';

const lazyModule = new LazyModule(() => import(/* webpackChunkName: "Fluid" */ './lazyIndex'));

export type LazyFluidPlugin = LazyPlugin<FluidPlugin>;

export const LazyFluidPluginClass = createLazyPlugin(
    lazyModule,
    m => m.FluidPlugin,
    PluginNames.Fluid,
    event => event.eventType == PluginEventType.EditorReady
);

export const lazyMountFluidComponent = new LazyImport(
    lazyModule,
    m => m.mountExistingFluidComponent
);

export const lazyTryGetFluidDriverForUrl = new LazyImport(
    lazyModule,
    m => m.tryGetFluidDriverForUrl
);

export const lazyCreateNewFluidComponent = new LazyImport(
    lazyModule,
    m => m.createNewFluidComponent
);

export const lazyGetAgendaCodeDetails = new LazyImport(lazyModule, m => m.getAgendaCodeDetails);

export const lazyGetFluidMenuItems = new LazyAction(lazyModule, m => m.getFluidMenuItems);

export const lazyCreateFluidForms = new LazyAction(lazyModule, m => m.createFluidForms);

export const lazyIsLoopUrl = new LazyAction(lazyModule, m => m.isLoopUrl);

export const lazyProviderCallbacksStore = new LazyImport(
    lazyModule,
    m => m.LoopProviderCallbackStore
);

// Lazy orchestrators
// Used to prefetch scripts, tokens, and the discover manifest (for create new).
registerLazyOrchestrator(preloadFluid, lazyModule, m => m.preloadFluidOrchestrator);
registerLazyOrchestrator(preloadFluidScripts, lazyModule, m => m.preloadFluidScriptsOrchestrator);

export const lazyPreloadFluidInCollabSpace = new LazyAction(lazyModule, m => m.preloadFluidScripts);

export const lazyIsPreloadFluidInCollabSpaceComplete = new LazyAction(
    lazyModule,
    m => m.isPreloadFluidInCollabSpaceComplete
);

export type { FluidContextualTeachingBubbleWrapperProps } from './components/FluidContextualTeachingBubble';
export const LazyFluidContextualTeachingBubble = createLazyComponent(
    lazyModule,
    m => m.FluidContextualTeachingBubbleWrapper
);

export type {
    FluidContainerConfigForEditor,
    FluidContainerConfigForDiv,
} from './store/schema/FluidContainerConfig';
export type {
    NewFluidContainerConfigForEditor,
    NewFluidContainerConfigForDiv,
} from './store/schema/NewFluidContainerConfig';
export type { FluidCallbackProps } from './store/schema/FluidCallbackProps';
export type { LoopProviderCallbacks } from './store/schema/FluidRenderProps';
export type { FluidRenderCustomizationProps } from './store/schema/FluidRenderCustomizationProps';

export { onFluidComponentRendered } from './actions/publicActions';
export { FLUID_HERO_MENU_ID, FLUID_CONTAINER } from './utils/constants';
